import { Component, Output, EventEmitter, ViewChild, Input, ChangeDetectorRef } from '@angular/core';
import { UntypedFormControl, Validators, AbstractControl } from '@angular/forms';
import { FlagGroup } from '../../../../shared/interfaces';
import { ModalDirective } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-group-name-modal',
  templateUrl: './group-name-modal.component.html',
  styleUrls: ['./group-name-modal.component.scss'],
})
export class GroupNameModalComponent {
  groups: FlagGroup[] = [];
  allGroups: FlagGroup[] = [];
  @Output() createGroup = new EventEmitter<string>();
  @Output() mergeInGroup = new EventEmitter<FlagGroup>();
  @Output() showGroupTemplate = new EventEmitter<void>();

  @ViewChild('childModal', { static: true }) public childModal: ModalDirective;

  groupNameControl = new UntypedFormControl('', [Validators.required, this.groupNameValidator.bind(this)]);
  chosenControl = new UntypedFormControl(null, [Validators.required]);
  canApplyTemplate = true;

  constructor(private cdr: ChangeDetectorRef) {}

  ngOnInit() {
    this.childModal.onHidden.subscribe(x => {
      if (x.dismissReason === 'esc' || x.dismissReason === 'backdrop-click') {
        this.cancel();
      }
    });

    this.groupNameControl.valueChanges.subscribe(value => {
      if (value) {
        this.chosenControl.reset();
      }
    });

    this.chosenControl.valueChanges.subscribe(value => {
      if (value) {
        this.groupNameControl.reset();
      }
    });
  }

  groupNameValidator(control: AbstractControl): { [key: string]: any } | null {
    if (this.allGroups && control.value) {
      const groupName = control.value.trim();
      const groupExists = this.allGroups.find(g => g.name.toUpperCase() === groupName.toUpperCase());
      if (groupExists) {
        return { flagGroupExists: { value: control.value } };
      }
    }
    return null;
  }

  save() {
    const name = (this.groupNameControl.value || '').trim();
    const chosen = this.chosenControl.value;

    // create new group
    if (name) {
      this.createGroup.emit(name);
      this.cancel();
      return;
    }

    if (chosen) {
      this.mergeInGroup.emit(chosen);
      this.cancel();
      return;
    }

    this.cancel();
  }

  show(groups: FlagGroup[], allGroups: FlagGroup[] = [], applyTemplate: boolean = true) {
    this.groups = groups;
    this.allGroups = allGroups;
    this.chosenControl.reset();
    this.groupNameControl.reset();
    this.childModal.show();
    this.canApplyTemplate = applyTemplate;
    this.cdr.detectChanges();
  }

  cancel() {
    this.childModal.hide();
  }

  hasGroupNameError(): boolean {
    return this.groupNameControl.invalid && this.groupNameControl.getError('flagGroupExists');
  }

  applyTemplate() {
    this.showGroupTemplate.emit();
    this.cancel();
  }
}
